///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.brand_promos = abcsetup.brand_promos || {};
abcsetup.brand_promos.audit_logs = abcsetup.brand_promos.audit_logs || {};



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.brand_promos.audit_logs = {
    fieldsInit: function () {
        // Maintenance History button clicked
        $(document).on('click', ".brand-promo-audit-link", function () {
            $(this).css("cursor", "progress");
            abcsetup.blockUI(true);
            axios.get('/brand_promos/audit_logs/' + $(this).data("audit-id")).then(response => {
                $(response.data).modal('show');
                abcsetup.unblockUI();
                $(this).css("cursor", "pointer");
            });
        });
    }
};